export const SECTION_PAD_X = 40;

export const DEFAULT_SECTION_DURATION = 5 * 60;

export const USER_TYPES = {
	OWNER: 'OWNER',
	PARTICIPANT: 'PARTICIPANT',
};
